import React from 'react';

import AssignmentIcon from '@material-ui/icons/Assignment';

import {
  PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR,
  PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR,
  PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR,
  PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR,
  PERMISSAO_TELA_MAPAS_LOJA_LISTAR,
  PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR,
} from '../../../utils/dadosTelas';
import SubMenu from '../SubMenu';

const SubMenuLogistica = ({
  classes,
  open,
  onMenuClick,
  isOpen,
  handleToggle,
  hasResource,
  permissoes,
}) => (
  <SubMenu
    handleToggle={handleToggle}
    isOpen={isOpen}
    sidebarIsOpen={open}
    name="Logistica"
    icon={<AssignmentIcon className={classes.icon} />}
  >
    {permissoes[PERMISSAO_TELA_ENDERECOS_EXPOSICAO_LISTAR] &&
      hasResource('enderecos_exposicao_mercadorias')}
    {permissoes[PERMISSAO_TELA_PRODUTOS_EXPOSICAO_LISTAR] &&
      hasResource('produtos_exposicao')}
    {permissoes[PERMISSAO_TELA_SAIDAS_ENDERECOS_EXPOSICAO_LISTAR] &&
      hasResource('enderecos_exposicao_movimentacoes')}
    {permissoes[PERMISSAO_TELA_SAIDAS_EMPILHADOR_LISTAR] &&
      hasResource('saidas_empilhador')}
    {permissoes[PERMISSAO_TELA_MAPAS_LOJA_LISTAR] && hasResource('mapas_loja')}
    {permissoes[PERMISSAO_TELA_EXPOSICAO_LOJA_LISTAR] &&
      hasResource('exposicao_loja')}
  </SubMenu>
);

export default SubMenuLogistica;
